import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  $pinnedCollapsed = new BehaviorSubject<boolean>(false);
  $collapsed = new BehaviorSubject<boolean>(false);
  $isAnimating = new BehaviorSubject<boolean>(false);

  setCollapsed(collapsed: boolean) {
    this.$pinnedCollapsed.next(collapsed);
    this.$collapsed.next(collapsed);
  }

  toggleCollapsed() {
    this.$isAnimating.next(true);

    const collapsed = this.$pinnedCollapsed.getValue();
    this.setCollapsed(!collapsed);

    setTimeout(() => {
      this.$isAnimating.next(false);
    }, 200);
  }

  expandOnHover() {
    if (this.$pinnedCollapsed.getValue()) {
      this.$collapsed.next(false);
    }
  }

  collapseOnHoverEnd() {
    if (this.$pinnedCollapsed.getValue()) {
      this.$collapsed.next(true);
    }
  }
}
